module.exports = __webpack_public_path__ + "static/media/jse2.02f24b19.png";